import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classStaticPrivateMethodGet(receiver, classConstructor, method) { _classCheckPrivateStaticAccess(receiver, classConstructor); return method; }
function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */
import { getAddress as _getAddress } from "../address/index.js";
import { ZeroAddress } from "../constants/index.js";
import { Contract } from "../contract/index.js";
import { dnsEncode, namehash } from "../hash/index.js";
import { hexlify, isHexString, toBeHex, defineProperties, encodeBase58, assert, assertArgument, isError, FetchRequest } from "../utils/index.js";
// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function getIpfsLink(link) {
  if (link.match(/^ipfs:\/\/ipfs\//i)) {
    link = link.substring(12);
  } else if (link.match(/^ipfs:\/\//i)) {
    link = link.substring(7);
  } else {
    assertArgument(false, "unsupported IPFS format", "link", link);
  }
  return "https://gateway.ipfs.io/ipfs/".concat(link);
}
;
;
/**
 *  A provider plugin super-class for processing multicoin address types.
 */
export var MulticoinProviderPlugin = /*#__PURE__*/function () {
  /**
   *  The name.
   */

  /**
   *  Creates a new **MulticoinProviderPluing** for %%name%%.
   */
  function MulticoinProviderPlugin(name) {
    _classCallCheck(this, MulticoinProviderPlugin);
    _defineProperty(this, "name", void 0);
    defineProperties(this, {
      name: name
    });
  }
  _createClass(MulticoinProviderPlugin, [{
    key: "connect",
    value: function connect(proivder) {
      return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */
  }, {
    key: "supportsCoinType",
    value: function supportsCoinType(coinType) {
      return false;
    }
    /**
     *  Resovles to the encoded %%address%% for %%coinType%%.
     */
  }, {
    key: "encodeAddress",
    value: function () {
      var _encodeAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(coinType, address) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              throw new Error("unsupported coin");
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function encodeAddress(_x, _x2) {
        return _encodeAddress.apply(this, arguments);
      }
      return encodeAddress;
    }()
    /**
     *  Resovles to the decoded %%data%% for %%coinType%%.
     */
  }, {
    key: "decodeAddress",
    value: function () {
      var _decodeAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(coinType, data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              throw new Error("unsupported coin");
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function decodeAddress(_x3, _x4) {
        return _decodeAddress.apply(this, arguments);
      }
      return decodeAddress;
    }()
  }]);
  return MulticoinProviderPlugin;
}();
var BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
/**
 *  A **BasicMulticoinProviderPlugin** provides service for common
 *  coin types, which do not require additional libraries to encode or
 *  decode.
 */
export var BasicMulticoinProviderPlugin = /*#__PURE__*/function (_MulticoinProviderPlu) {
  _inherits(BasicMulticoinProviderPlugin, _MulticoinProviderPlu);
  var _super = _createSuper(BasicMulticoinProviderPlugin);
  /**
   *  Creates a new **BasicMulticoinProviderPlugin**.
   */
  function BasicMulticoinProviderPlugin() {
    _classCallCheck(this, BasicMulticoinProviderPlugin);
    return _super.call(this, BasicMulticoinPluginId);
  }
  return _createClass(BasicMulticoinProviderPlugin);
}(MulticoinProviderPlugin);
var matcherIpfs = new RegExp("^(ipfs):/\/(.*)$", "i");
var matchers = [new RegExp("^(https):/\/(.*)$", "i"), new RegExp("^(data):(.*)$", "i"), matcherIpfs, new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")];
/**
 *  A connected object to a resolved ENS name resolver, which can be
 *  used to query additional details.
 */
var _supports = /*#__PURE__*/new WeakMap();
var _resolver = /*#__PURE__*/new WeakMap();
var _fetch = /*#__PURE__*/new WeakSet();
export var EnsResolver = /*#__PURE__*/function () {
  /**
   *  The connected provider.
   */

  /**
   *  The address of the resolver.
   */

  /**
   *  The name this resolver was resolved against.
   */

  // For EIP-2544 names, the ancestor that provided the resolver

  function EnsResolver(provider, address, name) {
    _classCallCheck(this, EnsResolver);
    _classPrivateMethodInitSpec(this, _fetch);
    _defineProperty(this, "provider", void 0);
    _defineProperty(this, "address", void 0);
    _defineProperty(this, "name", void 0);
    _classPrivateFieldInitSpec(this, _supports, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _resolver, {
      writable: true,
      value: void 0
    });
    defineProperties(this, {
      provider: provider,
      address: address,
      name: name
    });
    _classPrivateFieldSet(this, _supports, null);
    _classPrivateFieldSet(this, _resolver, new Contract(address, ["function supportsInterface(bytes4) view returns (bool)", "function resolve(bytes, bytes) view returns (bytes)", "function addr(bytes32) view returns (address)", "function addr(bytes32, uint) view returns (bytes)", "function text(bytes32, string) view returns (string)", "function contenthash(bytes32) view returns (bytes)"], provider));
  }
  /**
   *  Resolves to true if the resolver supports wildcard resolution.
   */
  _createClass(EnsResolver, [{
    key: "supportsWildcard",
    value: function () {
      var _supportsWildcard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_classPrivateFieldGet(this, _supports) == null) {
                _classPrivateFieldSet(this, _supports, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return _classPrivateFieldGet(_this, _resolver).supportsInterface("0x9061b923");
                      case 3:
                        return _context3.abrupt("return", _context3.sent);
                      case 6:
                        _context3.prev = 6;
                        _context3.t0 = _context3["catch"](0);
                        if (!isError(_context3.t0, "CALL_EXCEPTION")) {
                          _context3.next = 10;
                          break;
                        }
                        return _context3.abrupt("return", false);
                      case 10:
                        // Let future attempts try again...
                        _classPrivateFieldSet(_this, _supports, null);
                        throw _context3.t0;
                      case 12:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[0, 6]]);
                }))());
              }
              _context4.next = 3;
              return _classPrivateFieldGet(this, _supports);
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function supportsWildcard() {
        return _supportsWildcard.apply(this, arguments);
      }
      return supportsWildcard;
    }()
  }, {
    key: "getAddress",
    value:
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */
    function () {
      var _getAddress2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(coinType) {
        var result, ethCoinType, _data, coinPlugin, _iterator, _step, plugin, data, address;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (coinType == null) {
                coinType = 60;
              }
              if (!(coinType === 60)) {
                _context5.next = 16;
                break;
              }
              _context5.prev = 2;
              _context5.next = 5;
              return _classPrivateMethodGet(this, _fetch, _fetch2).call(this, "addr(bytes32)");
            case 5:
              result = _context5.sent;
              if (!(result == null || result === ZeroAddress)) {
                _context5.next = 8;
                break;
              }
              return _context5.abrupt("return", null);
            case 8:
              return _context5.abrupt("return", result);
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](2);
              if (!isError(_context5.t0, "CALL_EXCEPTION")) {
                _context5.next = 15;
                break;
              }
              return _context5.abrupt("return", null);
            case 15:
              throw _context5.t0;
            case 16:
              if (!(coinType >= 0 && coinType < 0x80000000)) {
                _context5.next = 23;
                break;
              }
              ethCoinType = coinType + 0x80000000;
              _context5.next = 20;
              return _classPrivateMethodGet(this, _fetch, _fetch2).call(this, "addr(bytes32,uint)", [ethCoinType]);
            case 20:
              _data = _context5.sent;
              if (!isHexString(_data, 20)) {
                _context5.next = 23;
                break;
              }
              return _context5.abrupt("return", _getAddress(_data));
            case 23:
              coinPlugin = null;
              _iterator = _createForOfIteratorHelper(this.provider.plugins);
              _context5.prev = 25;
              _iterator.s();
            case 27:
              if ((_step = _iterator.n()).done) {
                _context5.next = 36;
                break;
              }
              plugin = _step.value;
              if (plugin instanceof MulticoinProviderPlugin) {
                _context5.next = 31;
                break;
              }
              return _context5.abrupt("continue", 34);
            case 31:
              if (!plugin.supportsCoinType(coinType)) {
                _context5.next = 34;
                break;
              }
              coinPlugin = plugin;
              return _context5.abrupt("break", 36);
            case 34:
              _context5.next = 27;
              break;
            case 36:
              _context5.next = 41;
              break;
            case 38:
              _context5.prev = 38;
              _context5.t1 = _context5["catch"](25);
              _iterator.e(_context5.t1);
            case 41:
              _context5.prev = 41;
              _iterator.f();
              return _context5.finish(41);
            case 44:
              if (!(coinPlugin == null)) {
                _context5.next = 46;
                break;
              }
              return _context5.abrupt("return", null);
            case 46:
              _context5.next = 48;
              return _classPrivateMethodGet(this, _fetch, _fetch2).call(this, "addr(bytes32,uint)", [coinType]);
            case 48:
              data = _context5.sent;
              if (!(data == null || data === "0x")) {
                _context5.next = 51;
                break;
              }
              return _context5.abrupt("return", null);
            case 51:
              _context5.next = 53;
              return coinPlugin.decodeAddress(coinType, data);
            case 53:
              address = _context5.sent;
              if (!(address != null)) {
                _context5.next = 56;
                break;
              }
              return _context5.abrupt("return", address);
            case 56:
              assert(false, "invalid coin data", "UNSUPPORTED_OPERATION", {
                operation: "getAddress(".concat(coinType, ")"),
                info: {
                  coinType: coinType,
                  data: data
                }
              });
            case 57:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 11], [25, 38, 41, 44]]);
      }));
      function getAddress(_x5) {
        return _getAddress2.apply(this, arguments);
      }
      return getAddress;
    }()
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */
  }, {
    key: "getText",
    value: function () {
      var _getText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key) {
        var data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _classPrivateMethodGet(this, _fetch, _fetch2).call(this, "text(bytes32,string)", [key]);
            case 2:
              data = _context6.sent;
              if (!(data == null || data === "0x")) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return", null);
            case 5:
              return _context6.abrupt("return", data);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getText(_x6) {
        return _getText.apply(this, arguments);
      }
      return getText;
    }()
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */
  }, {
    key: "getContentHash",
    value: function () {
      var _getContentHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var data, ipfs, scheme, length, swarm;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _classPrivateMethodGet(this, _fetch, _fetch2).call(this, "contenthash(bytes32)");
            case 2:
              data = _context7.sent;
              if (!(data == null || data === "0x")) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", null);
            case 5:
              // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
              ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
              if (!ipfs) {
                _context7.next = 11;
                break;
              }
              scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
              length = parseInt(ipfs[4], 16);
              if (!(ipfs[5].length === length * 2)) {
                _context7.next = 11;
                break;
              }
              return _context7.abrupt("return", "".concat(scheme, "://").concat(encodeBase58("0x" + ipfs[2])));
            case 11:
              // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
              swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
              if (!(swarm && swarm[1].length === 64)) {
                _context7.next = 14;
                break;
              }
              return _context7.abrupt("return", "bzz://".concat(swarm[1]));
            case 14:
              assert(false, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
                operation: "getContentHash()",
                info: {
                  data: data
                }
              });
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getContentHash() {
        return _getContentHash.apply(this, arguments);
      }
      return getContentHash;
    }()
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */
  }, {
    key: "getAvatar",
    value: function () {
      var _getAvatar2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var avatar;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this._getAvatar();
            case 2:
              avatar = _context8.sent;
              return _context8.abrupt("return", avatar.url);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAvatar() {
        return _getAvatar2.apply(this, arguments);
      }
      return getAvatar;
    }()
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */
  }, {
    key: "_getAvatar",
    value: function () {
      var _getAvatar3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var linkage, avatar, i, match, scheme, url, selector, owner, comps, tokenId, contract, tokenOwner, balance, metadataUrl, metadata, response, bytes, imageUrl, ipfs;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              linkage = [{
                type: "name",
                value: this.name
              }];
              _context9.prev = 1;
              _context9.next = 4;
              return this.getText("avatar");
            case 4:
              avatar = _context9.sent;
              if (!(avatar == null)) {
                _context9.next = 8;
                break;
              }
              linkage.push({
                type: "!avatar",
                value: ""
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 8:
              linkage.push({
                type: "avatar",
                value: avatar
              });
              i = 0;
            case 10:
              if (!(i < matchers.length)) {
                _context9.next = 109;
                break;
              }
              match = avatar.match(matchers[i]);
              if (!(match == null)) {
                _context9.next = 14;
                break;
              }
              return _context9.abrupt("continue", 106);
            case 14:
              scheme = match[1].toLowerCase();
              _context9.t0 = scheme;
              _context9.next = _context9.t0 === "https" ? 18 : _context9.t0 === "data" ? 18 : _context9.t0 === "ipfs" ? 20 : _context9.t0 === "erc721" ? 24 : _context9.t0 === "erc1155" ? 24 : 106;
              break;
            case 18:
              linkage.push({
                type: "url",
                value: avatar
              });
              return _context9.abrupt("return", {
                linkage: linkage,
                url: avatar
              });
            case 20:
              url = getIpfsLink(avatar);
              linkage.push({
                type: "ipfs",
                value: avatar
              });
              linkage.push({
                type: "url",
                value: url
              });
              return _context9.abrupt("return", {
                linkage: linkage,
                url: url
              });
            case 24:
              // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
              selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
              linkage.push({
                type: scheme,
                value: avatar
              });
              // The owner of this name
              _context9.next = 28;
              return this.getAddress();
            case 28:
              owner = _context9.sent;
              if (!(owner == null)) {
                _context9.next = 32;
                break;
              }
              linkage.push({
                type: "!owner",
                value: ""
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 32:
              comps = (match[2] || "").split("/");
              if (!(comps.length !== 2)) {
                _context9.next = 36;
                break;
              }
              linkage.push({
                type: "!".concat(scheme, "caip"),
                value: match[2] || ""
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 36:
              tokenId = comps[1];
              contract = new Contract(comps[0], [
              // ERC-721
              "function tokenURI(uint) view returns (string)", "function ownerOf(uint) view returns (address)",
              // ERC-1155
              "function uri(uint) view returns (string)", "function balanceOf(address, uint256) view returns (uint)"], this.provider); // Check that this account owns the token
              if (!(scheme === "erc721")) {
                _context9.next = 48;
                break;
              }
              _context9.next = 41;
              return contract.ownerOf(tokenId);
            case 41:
              tokenOwner = _context9.sent;
              if (!(owner !== tokenOwner)) {
                _context9.next = 45;
                break;
              }
              linkage.push({
                type: "!owner",
                value: tokenOwner
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 45:
              linkage.push({
                type: "owner",
                value: tokenOwner
              });
              _context9.next = 56;
              break;
            case 48:
              if (!(scheme === "erc1155")) {
                _context9.next = 56;
                break;
              }
              _context9.next = 51;
              return contract.balanceOf(owner, tokenId);
            case 51:
              balance = _context9.sent;
              if (balance) {
                _context9.next = 55;
                break;
              }
              linkage.push({
                type: "!balance",
                value: "0"
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 55:
              linkage.push({
                type: "balance",
                value: balance.toString()
              });
            case 56:
              _context9.next = 58;
              return contract[selector](tokenId);
            case 58:
              metadataUrl = _context9.sent;
              if (!(metadataUrl == null || metadataUrl === "0x")) {
                _context9.next = 62;
                break;
              }
              linkage.push({
                type: "!metadata-url",
                value: ""
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 62:
              linkage.push({
                type: "metadata-url-base",
                value: metadataUrl
              });
              // ERC-1155 allows a generic {id} in the URL
              if (scheme === "erc1155") {
                metadataUrl = metadataUrl.replace("{id}", toBeHex(tokenId, 32).substring(2));
                linkage.push({
                  type: "metadata-url-expanded",
                  value: metadataUrl
                });
              }
              // Transform IPFS metadata links
              if (metadataUrl.match(/^ipfs:/i)) {
                metadataUrl = getIpfsLink(metadataUrl);
              }
              linkage.push({
                type: "metadata-url",
                value: metadataUrl
              });
              // Get the token metadata
              metadata = {};
              _context9.next = 69;
              return new FetchRequest(metadataUrl).send();
            case 69:
              response = _context9.sent;
              response.assertOk();
              _context9.prev = 71;
              metadata = response.bodyJson;
              _context9.next = 87;
              break;
            case 75:
              _context9.prev = 75;
              _context9.t1 = _context9["catch"](71);
              _context9.prev = 77;
              linkage.push({
                type: "!metadata",
                value: response.bodyText
              });
              _context9.next = 86;
              break;
            case 81:
              _context9.prev = 81;
              _context9.t2 = _context9["catch"](77);
              bytes = response.body;
              if (bytes) {
                linkage.push({
                  type: "!metadata",
                  value: hexlify(bytes)
                });
              }
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 86:
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 87:
              if (metadata) {
                _context9.next = 90;
                break;
              }
              linkage.push({
                type: "!metadata",
                value: ""
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 90:
              linkage.push({
                type: "metadata",
                value: JSON.stringify(metadata)
              });
              // Pull the image URL out
              imageUrl = metadata.image;
              if (!(typeof imageUrl !== "string")) {
                _context9.next = 95;
                break;
              }
              linkage.push({
                type: "!imageUrl",
                value: ""
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 95:
              if (!imageUrl.match(/^(https:\/\/|data:)/i)) {
                _context9.next = 98;
                break;
              }
              _context9.next = 104;
              break;
            case 98:
              // Transform IPFS link to gateway
              ipfs = imageUrl.match(matcherIpfs);
              if (!(ipfs == null)) {
                _context9.next = 102;
                break;
              }
              linkage.push({
                type: "!imageUrl-ipfs",
                value: imageUrl
              });
              return _context9.abrupt("return", {
                url: null,
                linkage: linkage
              });
            case 102:
              linkage.push({
                type: "imageUrl-ipfs",
                value: imageUrl
              });
              imageUrl = getIpfsLink(imageUrl);
            case 104:
              linkage.push({
                type: "url",
                value: imageUrl
              });
              return _context9.abrupt("return", {
                linkage: linkage,
                url: imageUrl
              });
            case 106:
              i++;
              _context9.next = 10;
              break;
            case 109:
              _context9.next = 113;
              break;
            case 111:
              _context9.prev = 111;
              _context9.t3 = _context9["catch"](1);
            case 113:
              return _context9.abrupt("return", {
                linkage: linkage,
                url: null
              });
            case 114:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 111], [71, 75], [77, 81]]);
      }));
      function _getAvatar() {
        return _getAvatar3.apply(this, arguments);
      }
      return _getAvatar;
    }()
  }], [{
    key: "getEnsAddress",
    value: function () {
      var _getEnsAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(provider) {
        var network, ensPlugin;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return provider.getNetwork();
            case 2:
              network = _context10.sent;
              ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens"); // No ENS...
              assert(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
                operation: "getEnsAddress",
                info: {
                  network: network
                }
              });
              return _context10.abrupt("return", ensPlugin.address);
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function getEnsAddress(_x7) {
        return _getEnsAddress.apply(this, arguments);
      }
      return getEnsAddress;
    }()
  }, {
    key: "fromName",
    value:
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */
    function () {
      var _fromName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(provider, name) {
        var currentName, addr, resolver;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              currentName = name;
            case 1:
              if (!true) {
                _context11.next = 22;
                break;
              }
              if (!(currentName === "" || currentName === ".")) {
                _context11.next = 4;
                break;
              }
              return _context11.abrupt("return", null);
            case 4:
              if (!(name !== "eth" && currentName === "eth")) {
                _context11.next = 6;
                break;
              }
              return _context11.abrupt("return", null);
            case 6:
              _context11.next = 8;
              return _classStaticPrivateMethodGet(EnsResolver, EnsResolver, _getResolver).call(EnsResolver, provider, currentName);
            case 8:
              addr = _context11.sent;
              if (!(addr != null)) {
                _context11.next = 19;
                break;
              }
              resolver = new EnsResolver(provider, addr, name); // Legacy resolver found, using EIP-2544 so it isn't safe to use
              _context11.t0 = currentName !== name;
              if (!_context11.t0) {
                _context11.next = 16;
                break;
              }
              _context11.next = 15;
              return resolver.supportsWildcard();
            case 15:
              _context11.t0 = !_context11.sent;
            case 16:
              if (!_context11.t0) {
                _context11.next = 18;
                break;
              }
              return _context11.abrupt("return", null);
            case 18:
              return _context11.abrupt("return", resolver);
            case 19:
              // Get the parent node
              currentName = currentName.split(".").slice(1).join(".");
              _context11.next = 1;
              break;
            case 22:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function fromName(_x8, _x9) {
        return _fromName.apply(this, arguments);
      }
      return fromName;
    }()
  }]);
  return EnsResolver;
}();
function _fetch2(_x10, _x11) {
  return _fetch3.apply(this, arguments);
}
function _fetch3() {
  _fetch3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(funcName, params) {
    var iface, fragment, _classPrivateFieldGet2, result;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          params = (params || []).slice();
          iface = _classPrivateFieldGet(this, _resolver).interface; // The first parameters is always the nodehash
          params.unshift(namehash(this.name));
          fragment = null;
          _context12.next = 6;
          return this.supportsWildcard();
        case 6:
          if (!_context12.sent) {
            _context12.next = 11;
            break;
          }
          fragment = iface.getFunction(funcName);
          assert(fragment, "missing fragment", "UNKNOWN_ERROR", {
            info: {
              funcName: funcName
            }
          });
          params = [dnsEncode(this.name), iface.encodeFunctionData(fragment, params)];
          funcName = "resolve(bytes,bytes)";
        case 11:
          params.push({
            ccipReadEnable: true
          });
          _context12.prev = 12;
          _context12.next = 15;
          return (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _resolver))[funcName].apply(_classPrivateFieldGet2, _toConsumableArray(params));
        case 15:
          result = _context12.sent;
          if (!fragment) {
            _context12.next = 18;
            break;
          }
          return _context12.abrupt("return", iface.decodeFunctionResult(fragment, result)[0]);
        case 18:
          return _context12.abrupt("return", result);
        case 21:
          _context12.prev = 21;
          _context12.t0 = _context12["catch"](12);
          if (isError(_context12.t0, "CALL_EXCEPTION")) {
            _context12.next = 25;
            break;
          }
          throw _context12.t0;
        case 25:
          return _context12.abrupt("return", null);
        case 26:
        case "end":
          return _context12.stop();
      }
    }, _callee12, this, [[12, 21]]);
  }));
  return _fetch3.apply(this, arguments);
}
function _getResolver(_x12, _x13) {
  return _getResolver3.apply(this, arguments);
}
function _getResolver3() {
  _getResolver3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(provider, name) {
    var ensAddr, contract, addr;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return EnsResolver.getEnsAddress(provider);
        case 2:
          ensAddr = _context13.sent;
          _context13.prev = 3;
          contract = new Contract(ensAddr, ["function resolver(bytes32) view returns (address)"], provider);
          _context13.next = 7;
          return contract.resolver(namehash(name), {
            enableCcipRead: true
          });
        case 7:
          addr = _context13.sent;
          if (!(addr === ZeroAddress)) {
            _context13.next = 10;
            break;
          }
          return _context13.abrupt("return", null);
        case 10:
          return _context13.abrupt("return", addr);
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](3);
          throw _context13.t0;
        case 16:
          return _context13.abrupt("return", null);
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[3, 13]]);
  }));
  return _getResolver3.apply(this, arguments);
}